import { render, staticRenderFns } from "./RightPaneProjectListRow.vue?vue&type=template&id=ebd97ffc&scoped=true&"
import script from "./RightPaneProjectListRow.vue?vue&type=script&lang=js&"
export * from "./RightPaneProjectListRow.vue?vue&type=script&lang=js&"
import style0 from "./RightPaneProjectListRow.vue?vue&type=style&index=0&lang=css&"
import style1 from "./RightPaneProjectListRow.vue?vue&type=style&index=1&id=ebd97ffc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd97ffc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
